import BaseSportPage from '../components/shared/BaseSportPage';
export default function Rugby() {
  return <BaseSportPage sport="rugby" label="Rugby" />;
}
